import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import { PostDetail } from '@/lib/services/postService';
import { formatDistanceToNow } from 'date-fns';
import { Calendar } from 'lucide-react';
import Link from 'next/link';
import TagBadge from '../tag-badge';
import FeedPostAuthor from './feed-post-author';
interface FeedPostProps {
      post: PostDetail;
      baseUrl?: string;
      openInNewTab?: boolean;
}

const FeedPost = ({ post, baseUrl = '/news', openInNewTab = false }: FeedPostProps) => {
      return (
            <Link href={`${baseUrl}/${post.slug}`} target={openInNewTab ? '_blank' : '_self'}>
                  <Card className="lg:mb-6 overflow-hidden shadow-none border-none ">
                        <CardHeader className="flex flex-col w-full">
                              <div className="flex flex-row items-center justify-between w-full">
                                    <h4 className="font-semibold">{post.title}</h4>
                                    <span className="text-xs text-gray-500 flex items-center gap-2">
                                          <Calendar className='size-4' /> {formatDistanceToNow(new Date(post.publishedAt ?? post.createdAt), { addSuffix: true })}
                                    </span>
                              </div>
                        </CardHeader>
                        <CardContent className=" text-gray-600">
                              <p>{post.summary}</p>
                        </CardContent>
                        <CardFooter className="flex flex-row items-center justify-between w-full">
                              <div className="flex flex-col items-center gap-2">
                                    <FeedPostAuthor author={post.author} />
                              </div>
                              <div className="flex flex-row flex-wrap gap-2">
                                    {post.tags.map((tag) => (
                                          <TagBadge key={tag.tag.id} tag={tag.tag} />
                                    ))}
                              </div>
                        </CardFooter>
                  </Card>
            </Link >
      );
};

export default FeedPost;